// extracted by mini-css-extract-plugin
export default {"root":"CourierOrderList-root-cf6e"};